import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useIsSmallScreen = () => {
    const theme = useTheme();
    return useMediaQuery("(max-width:900px)");
};

export default useIsSmallScreen;
